import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';
import { useState } from 'react';

export type LoginSetNewPasswordFields = {
  oldPassword: string;
  newPassword: string;
};

interface LoginSetNewPasswordProps {
  onNewPasswordSubmit: (data: LoginSetNewPasswordFields) => void;
  error?: string; // Optional error property
}

export const LoginNewPasswordForm: React.FC<LoginSetNewPasswordProps> = ({
  onNewPasswordSubmit,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control } = useForm<LoginSetNewPasswordFields>({
    defaultValues: {
      oldPassword: '',
      newPassword: '',
    },
  });

  return (
    <form className="login-form" onSubmit={handleSubmit(onNewPasswordSubmit)}>
      <ControlledInput
        control={control}
        name="oldPassword"
        rules={{ required: true }}
        inputProps={{
          type: showPassword ? 'text' : 'password',
          placeholder: 'Old password',
          className: 'input-form',
          fullWidth: true,
          autoFocus: true,
        }}
      />
      <div className="password-container">
        <ControlledInput
          control={control}
          name="newPassword"
          rules={{ required: true }}
          inputProps={{
            type: showPassword ? 'text' : 'password',
            placeholder: 'New password',
            className: 'input-form',
            fullWidth: true,
          }}
        />
        <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? '🔒' : '👀'}
        </span>
      </div>
      {error && (
        <p className="error-message" role="alert">
          {error}
        </p>
      )}
      <button className="login-submit" type="submit">
        Set New Password
      </button>
    </form>
  );
};
